module.exports = {"message":"hello i18n !!"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 0